/* ============================================
   PERSONALIZED LOVE NECKLACE — PRODUCT JS
   ============================================ */
(function() {
  'use strict';

  var section = document.querySelector('.nj-product[data-pln-variants]');
  if (!section) return;

  /* ── Data ── */
  var variants = JSON.parse(section.getAttribute('data-pln-variants') || '[]');
  var variantSelect = document.getElementById('nj-variant-select');
  var priceEl = section.querySelector('.nj-product__price-now') || section.querySelector('.nj-product__price');
  var atcBtn = section.querySelector('.nj-product__atc');
  var atcLabel = document.getElementById('pln-atc-label');
  var atcSubtitle = document.getElementById('pln-atc-subtitle');

  /* ── Heart Cards ── */
  var mainCards = section.querySelectorAll('.pln-hearts__card[data-main-heart]');
  var mainHeartBtns = section.querySelectorAll('.pln-hearts__btn[data-main-heart]');
  var mainColors = section.querySelectorAll('[data-main-color]');
  var mainSizes = section.querySelectorAll('[data-main-size]');

  var bogoCards = section.querySelectorAll('.pln-hearts__card[data-bogo-heart]');
  var bogoHeartBtns = section.querySelectorAll('.pln-hearts__btn[data-bogo-heart]');
  var bogoColors = section.querySelectorAll('[data-bogo-color]');
  var bogoSizes = section.querySelectorAll('[data-bogo-size]');

  /* ── Color labels (to update text) ── */
  var mainColorLabels = section.querySelectorAll('.pln-option [data-main-color]');
  var bogoColorLabels = section.querySelectorAll('.pln-bogo .pln-option [data-bogo-color]');

  /* ── State ── */
  var state = {
    bogoMode: 'same', // 'same' (BOGO mirrors main) or 'custom' (user configures BOGO separately)
    main: { hearts: '1 Heart', color: 'Gold', size: '45cm' },
    bogo: { hearts: '1 Heart', color: 'Gold', size: '45cm' }
  };

  /* ── Mode toggle elements ── */
  var bogoModeRadios = section.querySelectorAll('input[name="pln-bogo-mode"]');
  var bogoModeOptions = section.querySelectorAll('.pln-bogo__mode-option');
  var bogoBody = document.getElementById('pln-bogo-body');
  var bogoSameSummary = document.getElementById('pln-bogo-same-summary');

  /* ══════════════════════════════════════
     HELPERS
     ══════════════════════════════════════ */
  function findVariant(hearts, color, size) {
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].option1 === hearts && variants[i].option2 === color && variants[i].option3 === size) {
        return variants[i];
      }
    }
    return null;
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function getBogoUpgradeCents() {
    // In "same" mode, BOGO mirrors main exactly — upgrade matches main hearts
    var src = state.bogoMode === 'same' ? state.main : state.bogo;
    var heartCount = parseInt(src.hearts);
    return (heartCount - 1) * 350; // $3.50 per extra heart
  }

  /* ── Update the "Same as above" summary line — shown when 2/3 hearts selected in 'same' mode ── */
  function updateBogoSameSummary() {
    if (!bogoSameSummary) return;
    // Only show this line when we're in "Same as above" mode
    if (state.bogoMode !== 'same') {
      bogoSameSummary.setAttribute('hidden', '');
      bogoSameSummary.innerHTML = '';
      return;
    }
    var heartCount = parseInt(state.main.hearts);
    if (heartCount <= 1) {
      // 1 heart = truly free, no upgrade cost, no line needed
      bogoSameSummary.setAttribute('hidden', '');
      bogoSameSummary.innerHTML = '';
      return;
    }
    var upgradeCents = (heartCount - 1) * 350;
    bogoSameSummary.removeAttribute('hidden');
    bogoSameSummary.innerHTML = state.main.hearts + ' necklace — <strong>+' + formatMoney(upgradeCents) + ' upgrade</strong>';
  }

  /* ── Sync BOGO state to match main (used in 'same' mode) ── */
  function syncBogoToMain() {
    state.bogo.hearts = state.main.hearts;
    state.bogo.color = state.main.color;
    state.bogo.size = state.main.size;

    // Visually sync the BOGO selectors too, so if user switches to "custom" the UI is pre-selected correctly
    bogoCards.forEach(function(card) {
      card.classList.toggle('pln-hearts__card--active', card.getAttribute('data-bogo-heart') === state.bogo.hearts);
    });
    bogoHeartBtns.forEach(function(btn) {
      btn.classList.toggle('pln-hearts__btn--active', btn.getAttribute('data-bogo-heart') === state.bogo.hearts);
    });
    bogoColors.forEach(function(btn) {
      btn.classList.toggle('pln-colors__btn--active', btn.getAttribute('data-bogo-color') === state.bogo.color);
    });
    bogoSizes.forEach(function(btn) {
      btn.classList.toggle('pln-sizes__btn--active', btn.getAttribute('data-bogo-size') === state.bogo.size);
    });
    updateColorLabel(false);
  }

  /* ══════════════════════════════════════
     PRICE DISPLAY — always show on ATC
     ══════════════════════════════════════ */
  function updateAllPrices() {
    var mainV = findVariant(state.main.hearts, state.main.color, state.main.size);
    if (!mainV) return;

    // Total = main product + BOGO upgrade
    var total = mainV.price + getBogoUpgradeCents();

    // Top price display — shows the TOTAL (main + BOGO upgrade)
    if (priceEl) priceEl.textContent = formatMoney(total);

    // ATC button — same total
    if (atcLabel) {
      atcLabel.textContent = 'ADD TO CART — ' + formatMoney(total);
    }

    updateBogoSameSummary();
  }

  /* ══════════════════════════════════════
     COLOR LABEL UPDATE
     ══════════════════════════════════════ */
  function updateColorLabel(isMain) {
    var color = isMain ? state.main.color : state.bogo.color;
    var labelId = isMain ? 'pln-main-color-label' : 'pln-bogo-color-label';
    var label = document.getElementById(labelId);
    if (!label) return;
    // Main label shows only the color name (no "Color —" prefix); BOGO keeps the original format
    if (isMain) {
      label.innerHTML = '<strong>' + color + '</strong>';
    } else {
      label.innerHTML = 'Color — <strong>' + color + '</strong>';
    }
  }

  /* ══════════════════════════════════════
     UPDATE FUNCTIONS
     ══════════════════════════════════════ */
  function updateMainVariant() {
    var v = findVariant(state.main.hearts, state.main.color, state.main.size);
    if (v && variantSelect) variantSelect.value = v.id;

    mainCards.forEach(function(card) {
      var isActive = card.getAttribute('data-main-heart') === state.main.hearts;
      card.classList.toggle('pln-hearts__card--active', isActive);
      if (!isActive) {
        card.querySelectorAll('.pln-hearts__name-input').forEach(function(inp) { inp.value = ''; });
      }
    });
    mainHeartBtns.forEach(function(btn) {
      btn.classList.toggle('pln-hearts__btn--active', btn.getAttribute('data-main-heart') === state.main.hearts);
    });

    updateColorLabel(true);

    // If BOGO is in "same" mode, keep it mirrored
    if (state.bogoMode === 'same') syncBogoToMain();

    updateAllPrices();
    validateNames();
  }

  function updateBogoVariant() {
    bogoCards.forEach(function(card) {
      var isActive = card.getAttribute('data-bogo-heart') === state.bogo.hearts;
      card.classList.toggle('pln-hearts__card--active', isActive);
      if (!isActive) {
        card.querySelectorAll('.pln-hearts__name-input').forEach(function(inp) { inp.value = ''; });
      }
    });
    bogoHeartBtns.forEach(function(btn) {
      btn.classList.toggle('pln-hearts__btn--active', btn.getAttribute('data-bogo-heart') === state.bogo.hearts);
    });

    updateColorLabel(false);
    updateAllPrices();
    validateNames();
  }

  /* ── Validation ── */
  function validateNames() {
    var allFilled = true;

    var activeMainCard = section.querySelector('.pln-hearts__card[data-main-heart].pln-hearts__card--active');
    if (activeMainCard) {
      activeMainCard.querySelectorAll('.pln-hearts__name-input').forEach(function(input) {
        if (!input.value.trim()) allFilled = false;
      });
    }

    // Only validate BOGO names when user chose to customize differently
    if (state.bogoMode === 'custom') {
      var activeBogoCard = section.querySelector('.pln-hearts__card[data-bogo-heart].pln-hearts__card--active');
      if (activeBogoCard) {
        activeBogoCard.querySelectorAll('.pln-hearts__name-input').forEach(function(input) {
          if (!input.value.trim()) allFilled = false;
        });
      }
    }

    if (atcBtn) atcBtn.disabled = !allFilled;
    if (atcSubtitle) {
      atcSubtitle.textContent = allFilled ? '' : 'Please fill in all name fields to continue';
    }
  }

  /* ══════════════════════════════════════
     EVENT LISTENERS — MAIN
     ══════════════════════════════════════ */
  mainHeartBtns.forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      state.main.hearts = btn.getAttribute('data-main-heart');
      updateMainVariant();
    });
  });

  mainColors.forEach(function(btn) {
    btn.addEventListener('click', function() {
      state.main.color = btn.getAttribute('data-main-color');
      mainColors.forEach(function(b) { b.classList.remove('pln-colors__btn--active'); });
      btn.classList.add('pln-colors__btn--active');
      updateMainVariant();
    });
  });

  mainSizes.forEach(function(btn) {
    btn.addEventListener('click', function() {
      state.main.size = btn.getAttribute('data-main-size');
      mainSizes.forEach(function(b) { b.classList.remove('pln-sizes__btn--active'); });
      btn.classList.add('pln-sizes__btn--active');
      updateMainVariant();
    });
  });

  section.querySelectorAll('.pln-hearts__name-input').forEach(function(input) {
    input.addEventListener('input', validateNames);
  });

  /* ══════════════════════════════════════
     EVENT LISTENERS — BOGO
     ══════════════════════════════════════ */
  bogoHeartBtns.forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      state.bogo.hearts = btn.getAttribute('data-bogo-heart');
      updateBogoVariant();
    });
  });

  bogoColors.forEach(function(btn) {
    btn.addEventListener('click', function() {
      state.bogo.color = btn.getAttribute('data-bogo-color');
      bogoColors.forEach(function(b) { b.classList.remove('pln-colors__btn--active'); });
      btn.classList.add('pln-colors__btn--active');
      updateBogoVariant();
    });
  });

  bogoSizes.forEach(function(btn) {
    btn.addEventListener('click', function() {
      state.bogo.size = btn.getAttribute('data-bogo-size');
      bogoSizes.forEach(function(b) { b.classList.remove('pln-sizes__btn--active'); });
      btn.classList.add('pln-sizes__btn--active');
      updateBogoVariant();
    });
  });

  /* ══════════════════════════════════════
     BOGO MODE TOGGLE — "Same as above" vs "Customize differently"
     ══════════════════════════════════════ */
  function applyBogoMode() {
    if (bogoBody) {
      if (state.bogoMode === 'same') {
        bogoBody.setAttribute('hidden', '');
        syncBogoToMain();
      } else {
        bogoBody.removeAttribute('hidden');
      }
    }
    bogoModeOptions.forEach(function(opt) {
      var input = opt.querySelector('input[name="pln-bogo-mode"]');
      opt.classList.toggle('pln-bogo__mode-option--active', input && input.value === state.bogoMode);
    });
    updateAllPrices();
    validateNames();
  }

  bogoModeRadios.forEach(function(radio) {
    radio.addEventListener('change', function() {
      if (radio.checked) {
        state.bogoMode = radio.value;
        applyBogoMode();
      }
    });
  });

  /* ══════════════════════════════════════
     ADD TO CART
     ══════════════════════════════════════
     The BOGO item is added at its REAL variant price.
     The cart drawer's _bogo_free logic discounts the base
     1-heart price ($45), so:
     - 1 Heart BOGO: $45 added, $45 discounted = FREE
     - 2 Hearts BOGO: $48.50 added, $45 discounted = $3.50 charge
     - 3 Hearts BOGO: $52 added, $45 discounted = $7 charge
     This carries through to checkout correctly.
     ══════════════════════════════════════ */
  function handleAddToCart(e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    if (atcBtn.disabled) return;

    // In "same" mode, BOGO mirrors main exactly before computing the variant
    if (state.bogoMode === 'same') syncBogoToMain();

    var mainVariant = findVariant(state.main.hearts, state.main.color, state.main.size);
    var bogoVariant = findVariant(state.bogo.hearts, state.bogo.color, state.bogo.size);
    if (!mainVariant) return;

    // Collect main names
    var mainProps = {};
    var activeMainCard = section.querySelector('.pln-hearts__card[data-main-heart].pln-hearts__card--active');
    if (activeMainCard) {
      activeMainCard.querySelectorAll('.pln-hearts__name-input').forEach(function(input, i) {
        mainProps['Name ' + (i + 1)] = input.value.trim();
      });
    }

    // Collect BOGO names — in 'same' mode we copy the main names; in 'custom' mode we read BOGO inputs
    var bogoProps = { '_bogo_free': 'true' };
    if (state.bogoMode === 'same') {
      Object.keys(mainProps).forEach(function(k) { bogoProps[k] = mainProps[k]; });
    } else {
      var activeBogoCard = section.querySelector('.pln-hearts__card[data-bogo-heart].pln-hearts__card--active');
      if (activeBogoCard) {
        activeBogoCard.querySelectorAll('.pln-hearts__name-input').forEach(function(input, i) {
          bogoProps['Name ' + (i + 1)] = input.value.trim();
        });
      }
    }

    // Build items — BOGO goes at its real variant price
    var items = [
      { id: mainVariant.id, quantity: 1, properties: mainProps }
    ];
    if (bogoVariant) {
      items.push({ id: bogoVariant.id, quantity: 1, properties: bogoProps });
    }

    atcBtn.disabled = true;
    if (atcLabel) atcLabel.textContent = 'ADDING...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      if (atcLabel) atcLabel.textContent = 'ADDED!';
      setTimeout(function() {
        atcBtn.disabled = false;
        updateAllPrices();
        validateNames();
      }, 1500);

      // Open and refresh cart drawer using exposed functions
      if (typeof window.njRefreshCartDrawer === 'function') {
        window.njRefreshCartDrawer();
      }
      if (typeof window.njOpenCartDrawer === 'function') {
        window.njOpenCartDrawer();
      } else {
        // Fallback manual open
        var cartDrawer = document.getElementById('jewelry-cart-drawer');
        if (cartDrawer) {
          cartDrawer.classList.add('jewelry-cart-drawer--open');
          document.body.style.overflow = 'hidden';
          document.body.style.position = 'fixed';
          document.body.style.width = '100%';
          document.body.style.top = '-' + window.scrollY + 'px';
        }
        var overlay = document.getElementById('jewelry-cart-overlay');
        if (overlay) { overlay.style.display = 'block'; overlay.classList.add('jewelry-cart-overlay--open'); }
      }
      // Also update cart count
      fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
        var countEls = document.querySelectorAll('.cart-count-bubble span, [data-cart-count]');
        countEls.forEach(function(el) { el.textContent = cart.item_count; });
      });
    })
    .catch(function(err) {
      console.error('Add to cart error:', err);
      atcBtn.disabled = false;
      updateAllPrices();
    });
  }

  var form = section.querySelector('form[action*="/cart/add"]');
  if (form) {
    form.addEventListener('submit', handleAddToCart, true);
  }
  if (atcBtn) {
    atcBtn.addEventListener('click', function(e) {
      if (atcBtn.disabled) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    });
  }

  /* ── Init ── */
  if (atcBtn) atcBtn.disabled = true;
  updateMainVariant();
  updateBogoVariant();
  applyBogoMode(); // default 'same' — hides BOGO body and syncs state
  updateAllPrices();

})();
